__turbopack_context__.v({
  "copy": "poCS3G_copy",
  "desc": "poCS3G_desc",
  "footerBottom": "poCS3G_footerBottom",
  "img": "poCS3G_img",
  "left": "poCS3G_left",
  "logo": "poCS3G_logo",
  "right": "poCS3G_right",
  "security": "poCS3G_security",
  "sideEffect": "poCS3G_sideEffect",
  "sm": "poCS3G_sm",
  "smLink": "poCS3G_smLink",
  "soc": "poCS3G_soc",
  "socLink": "poCS3G_socLink",
  "ssl": "poCS3G_ssl",
  "sslLink": "poCS3G_sslLink",
  "trademark": "poCS3G_trademark",
  "trademark2": "poCS3G_trademark2",
  "truste": "poCS3G_truste",
  "trusteLink": "poCS3G_trusteLink",
  "wrapper": "poCS3G_wrapper",
});
